@if (state.message()) {
<div class="side-snackbar" [class]="state.type()">
    <mat-icon>{{ icon }}</mat-icon>

    <span class="message">{{ state.message() }}</span>

    @if (state.closable()) {
    <button class="se-button-no-ripple" mat-icon-button (click)="state.clear()">
        <mat-icon>close</mat-icon>
    </button>
    }
</div>
}
